import { createFileRoute } from "@tanstack/react-router";
import { NewOrderScreen, type NewOrderSearch } from "../features/order/new-order-screen";
import { Require } from "../features/require";

export const Route = createFileRoute("/orders/new")({
	/** `table`: a free table's order; none: a takeaway. `add`: the item picker is open. */
	validateSearch: (search: Record<string, unknown>): NewOrderSearch => ({
		...(typeof search.table === "string" ? { table: search.table } : {}),
		...(search.add === true || search.add === "true" ? { add: true } : {}),
		...(search.from === "tables" ? { from: "tables" as const } : {}),
	}),
	component: Page,
});

function Page() {
	const search = Route.useSearch();
	return (
		<Require permission="order.create">
			<NewOrderScreen key={search.table ?? "takeaway"} search={search} />
		</Require>
	);
}
